export enum Chain {
  EthereumMainnet = 1,
  SepoliaTestnet = 11155111,
  HoleskyTestnet = 17000,
  ApeChainCurtisTestnet = 33111,
  ApeChainMainnet = 33139,
  ArbitrumNovaMainnet = 42170,
  ArbitrumOneMainnet = 42161,
  ArbitrumSepoliaTestnet = 421614,
  AvalancheCChain = 43114,
  AvalancheFujiTestnet = 43113,
  BaseMainnet = 8453,
  BaseSepoliaTestnet = 84532,
  BitTorrentChainMainnet = 199,
  BitTorrentChainTestnet = 1028,
  BlastMainnet = 81457,
  BlastSepoliaTestnet = 168587773,
  BNBSmartChainMainnet = 56,
  BNBSmartChainTestnet = 97,
  CeloAlfajoresTestnet = 44787,
  CeloMainnet = 42220,
  CronosMainnet = 25,
  FantomOperaMainnet = 250,
  FantomTestnet = 4002,
  FraxtalMainnet = 252,
  FraxtalTestnet = 2522,
  Gnosis = 100,
  KromaMainnet = 255,
  KromaSepoliaTestnet = 2358,
  LineaMainnet = 59144,
  LineaSepoliaTestnet = 59141,
  MantleMainnet = 5000,
  MantleSepoliaTestnet = 5003,
  MoonbaseAlphaTestnet = 1287,
  MoonbeamMainnet = 1284,
  MoonriverMainnet = 1285,
  OPMainnet = 10,
  OPSepoliaTestnet = 11155420,
  PolygonAmoyTestnet = 80002,
  PolygonMainnet = 137,
  PolygonZkEVMCardonaTestnet = 2442,
  PolygonZkEVMMainnet = 1101,
  ScrollMainnet = 534352,
  ScrollSepoliaTestnet = 534351,
  SonicBlazeTestnet = 57054,
  SonicMainnet = 146,
  SophonMainnet = 50104,
  SophonSepoliaTestnet = 531050104,
  TaikoHeklaL2Testnet = 167009,
  TaikoMainnet = 167000,
  WEMIXMainnet = 1111,
  WEMIXTestnet = 1112,
  WorldMainnet = 480,
  WorldSepoliaTestnet = 4801,
  XaiMainnet = 660279,
  XaiSepoliaTestnet = 37714555429,
  XDCApothemTestnet = 51,
  XDCMainnet = 50,
  zkSyncMainnet = 324,
  zkSyncSepoliaTestnet = 300
}
